import axios from 'axios'

import { ChanneledRequestParams, Department } from 'types'

export const getDepartments = async (params: ChanneledRequestParams) => {
  return (
    await axios.get<Department[]>('/departments', {
      params,
    })
  ).data
}
